
export const enabledTestFrequencies = ["WEEK_ONE", "WEEK_TWO"];